import React from 'react';
import { Observer } from 'mobx-react-lite';
import authContext from '../../stores/auth-store';
import deskContext from '../../stores/desk-store';
import LogExport from './components/log-export';
import TradeRecaps from './components/trade-recaps';
import { withRouter } from 'react-router';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { makeStyles } from '@material-ui/core/styles';
import { useTabQueryString } from '../../hooks/use-tab-query-string';

const useStyles = makeStyles({
  tabs: {
    paddingBottom: 20,
  },
  tab: {
    width: 220,
  },
});

const Compliance = () => {
  const auth = React.useContext(authContext);
  const desk = React.useContext(deskContext);
  const classes = useStyles();
  const { tab, setTab } = useTabQueryString('logs');

  React.useEffect(() => {
    desk.fetch();
  }, [desk]);

  return (
    <Observer>
      {() => {
        // Export Logs mails the desk's whole trade history to an
        // arbitrary address, so the tab is admin-only, mirroring
        // `CanManageTradingDesk` on the endpoint it calls. Trade
        // Recaps stays readable by every desk member.
        const canExportLogs = Boolean(auth.canManageTradingDesk);
        const activeTab = canExportLogs ? tab : 'recaps';

        return (
          <div data-testid="compliance-page">
            <Tabs
              value={activeTab}
              onChange={(_, selectedTab) => setTab(selectedTab)}
              className={classes.tabs}
            >
              {canExportLogs && (
                <Tab value="logs" className={classes.tab} label="Export Logs" />
              )}
              <Tab
                value="recaps"
                className={classes.tab}
                label="Trade Recaps"
              />
            </Tabs>
            {activeTab === 'logs' && <LogExport />}
            {activeTab === 'recaps' && <TradeRecaps />}
          </div>
        );
      }}
    </Observer>
  );
};

export default withRouter(Compliance);
